import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useEmailDisclosure({
	impersonationContext,
	templateId,
	enabled = true,
}: {
	impersonationContext?: Api.IImpersonationContext;
	templateId?: string;
	enabled?: boolean;
}) {
	const userSession = useUserSession();

	return useQuery({
		enabled: enabled && !!templateId,
		refetchOnWindowFocus: false,
		staleTime: 0,
		queryFn: () =>
			userSession.webServiceHelper.callAsync<string | null>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'email/resolvedDisclosure',
					queryParams: templateId ? { templateId } : undefined,
				}),
				'GET'
			),
		retry: 0,
		queryKey: ['emailDisclosure', { templateId, impersonationContextId: impersonationContext?.account?.id }],
	});
}
